import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";


const M_KEY = '/agent/ad/list' // 광고상세조회

const fetchKey = (id) =>
	`${M_KEY}/${id}`;

export function useAgentADInfo(id) {
	const { data: token } = useToken();

	const KEY = fetchKey(id);


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });
	let parseData = {...data};
	if(parseData.fileList) {
		try {
			parseData.fileList = JSON.parse(data.fileList)
		} catch (e) {
			parseData.fileList = []
		}
	} else {
		parseData.fileList = []
	}
	return { agentADInfo: parseData, mutateAgentADInfo: mutate};
}

async function fetchAPI(KEY:string, token:any)  {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return response.result?.result;
	} catch (error) {
		console.error('Failed to fetch Agent AD Info:', error);
		return { list: [], total: 0 };
	}
}